import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { green } from '@mui/material/colors';
import { makeStyles, withStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  table: {
    minWidth: 700,
  },
  search: {
    padding: '2px 2px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(4),
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  actions: {
    '& button:nth-of-type(2)': {
      marginLeft: '10px',
    },
  },
  formControl: {
    // margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50px',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export const StyledTableCell = withStyles(TableCell, (theme) => ({
  head: {
    backgroundColor: theme.palette.tableHead.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}));

export const StyledTableRow = withStyles(TableRow, (theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));
